/* SPH – Produktseite: Einheitspreise im Komplett-Set, Rabatt-Badge auf dem Bild, UVP + Rabatt in einer Zeile mit dem Preis */
(function () {
  function pctOf(id) { return (id % 21) + 20; }

  function badge() {
    var root = document.querySelector('[data-sph-product]') || document.querySelector('main');
    if (!root) return;
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m) return;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var onSale = (p.variants || []).some(function (v) { return v.compare_at_price && v.compare_at_price > v.price; });
        if (!onSale) return;
        var pct = pctOf(p.id);

        if (!document.querySelector('.sph-pimg-badge')) {
          var img = root.querySelector('.sph-gal img, media-gallery img, [class*="gallery"] img, img');
          if (img) {
            var host = img.closest('a, figure, div') || img.parentElement;
            if (host) {
              var cs = getComputedStyle(host);
              if (cs.position === 'static') host.style.position = 'relative';
              var b = document.createElement('span');
              b.className = 'sph-pimg-badge';
              b.textContent = '\u2212' + pct + ' %';
              b.style.cssText = 'position:absolute;top:10px;left:10px;z-index:5;padding:4px 10px;border-radius:3px;background:var(--sph-red,#BE000B);color:#fff;font-size:12px;font-weight:800;letter-spacing:.04em;line-height:1.4;pointer-events:none';
              host.appendChild(b);
            }
          }
        }

        /* Preis + UVP + Pill in EINER Zeile, MwSt-Hinweis darunter */
        function applyUvp() {
          var box = document.querySelector('.sph-sqm');
          if (!box || box.querySelector('.sph-uvp')) return;
          var tag = box.querySelector('b');
          if (!tag) return;
          var mm = (tag.textContent || '').replace(',', '.').match(/(\d+(?:\.\d+)?)/);
          if (!mm) return;
          var val = parseFloat(mm[1]);
          if (!val) return;
          var uvp = val / (1 - pct / 100);

          box.style.display = 'flex';
          box.style.flexWrap = 'wrap';
          box.style.alignItems = 'baseline';
          box.style.columnGap = '14px';
          tag.style.whiteSpace = 'nowrap';
          var vat = box.querySelector('small');
          if (vat) { vat.style.flexBasis = '100%'; vat.style.marginTop = '4px'; vat.style.marginLeft = '0'; }

          var wrap = document.createElement('span');
          wrap.className = 'sph-uvp';
          wrap.style.cssText = 'display:inline-flex;align-items:baseline;gap:10px;white-space:nowrap';
          var s = document.createElement('s');
          s.textContent = 'CHF ' + uvp.toFixed(2);
          s.style.cssText = 'font-size:15px;font-weight:500;color:#A3A3A3;text-decoration:line-through;letter-spacing:0;white-space:nowrap';
          var pill = document.createElement('em');
          pill.textContent = '\u2212' + pct + ' %';
          pill.style.cssText = 'font-style:normal;font-size:12px;font-weight:800;color:var(--sph-red,#BE000B);background:#FBE9EA;padding:2px 9px;border-radius:999px;line-height:1.5;letter-spacing:.02em;align-self:center;white-space:nowrap';
          wrap.appendChild(s);
          wrap.appendChild(pill);
          tag.insertAdjacentElement('afterend', wrap);
        }
        applyUvp();
        new MutationObserver(function () { applyUvp(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
      })
      .catch(function () {});
  }

  function boot() {
    badge();
    var root = document.querySelector('[data-sph-bundle]');
    if (!root) return;

    function unitInfo(text, cents, qty) {
      var m = text.match(/(\d{3,4})\s*mm\s*[\/x×]\s*(\d{3,4})\s*mm/i);
      if (m) {
        var m2 = (parseInt(m[1], 10) / 1000) * (parseInt(m[2], 10) / 1000);
        if (m2 > 0.05) return { d: cents / 100 / m2, u: 'm\u00b2' };
      }
      m = text.match(/(\d{3,4})\s*mm/i);
      if (m && parseInt(m[1], 10) >= 900) return { d: cents / 100 / (parseInt(m[1], 10) / 1000), u: 'm' };
      m = text.match(/(\d+(?:[.,]\d+)?)\s*m\b/i);
      if (m) {
        var len = parseFloat(m[1].replace(',', '.'));
        if (len >= 1) return { d: cents / 100 / len, u: 'm' };
      }
      m = text.match(/(\d+)\s*(st\u00fcck|stk|stck)/i);
      if (m && parseInt(m[1], 10) > 1) return { d: cents / 100 / parseInt(m[1], 10), u: 'St\u00fcck' };
      if (qty > 1) return { d: cents / 100, u: 'St\u00fcck' };
      return null;
    }

    function refresh() {
      root.querySelectorAll('[data-sph-item]').forEach(function (r) {
        var p = r.querySelector('[data-sph-itemp]');
        var v = r.querySelector('[data-sph-var]');
        if (!p || !v) return;
        p.style.position = 'relative';
        var small = p.querySelector('.sph-bundle-unitline');
        if (!small) {
          small = document.createElement('small');
          small.className = 'sph-bundle-unitline';
          small.style.cssText = 'position:absolute;top:100%;right:0;margin-top:1px;font-size:10.5px;line-height:1.2;font-weight:500;color:#8A8A8A;text-align:right;white-space:nowrap';
          p.appendChild(small);
        }
        var cents = 0, text = '';
        if (v.tagName === 'SELECT') {
          var o = v.options[v.selectedIndex];
          cents = o ? parseInt(o.getAttribute('data-price'), 10) : 0;
          text = o ? o.textContent : '';
        } else {
          cents = parseInt(v.getAttribute('data-price'), 10) || 0;
        }
        var q = r.querySelector('[data-sph-qty]');
        var qty = q ? parseInt(q.value, 10) || 1 : 1;
        var u = unitInfo(text, cents, qty);
        small.textContent = u ? 'CHF ' + u.d.toFixed(2) + ' / ' + u.u : '';
      });
    }

    root.addEventListener('change', function () { setTimeout(refresh, 20); });
    new MutationObserver(function () {
      if (!root.querySelector('.sph-bundle-unitline')) refresh();
    }).observe(root, { childList: true, subtree: true, characterData: true });
    refresh();
    setTimeout(refresh, 300);
    setTimeout(refresh, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
